export default __webpack_public_path__ + "static/noi2020bronzeivan-733e0d46e7ab965c9db7d5c9a75509e0.png";